(function () {
  var RESULT_PRIORITY = [
    "abstract",
    "minimalist",
    "botanical",
    "figurative",
    "geometric",
    "typographic",
    "landscape",
    "bold"
  ];

  function splitScores(value) {
    return String(value || "")
      .split(",")
      .map(function (item) {
        return item.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function getActiveStep(root) {
    var active = root.querySelector("[data-quiz-step].is-active");
    return active ? Number(active.getAttribute("data-quiz-step")) : 0;
  }

  function selectedAnswers(step) {
    return Array.prototype.slice.call(step.querySelectorAll("[data-answer][aria-pressed='true']"));
  }

  function setStep(root, nextStep) {
    var steps = Array.prototype.slice.call(root.querySelectorAll("[data-quiz-step]"));
    steps.forEach(function (step) {
      var isActive = Number(step.getAttribute("data-quiz-step")) === nextStep;
      step.classList.toggle("is-active", isActive);
      step.hidden = !isActive;
    });

    var progressItems = Array.prototype.slice.call(root.querySelectorAll("[data-progress-step]"));
    progressItems.forEach(function (item) {
      var isCurrent = Number(item.getAttribute("data-progress-step")) === nextStep;
      if (isCurrent) {
        item.setAttribute("aria-current", "step");
      } else {
        item.removeAttribute("aria-current");
      }
    });

    var progressBar = root.querySelector("[data-progress-bar]");
    if (progressBar) {
      progressBar.style.width = ((nextStep + 1) / steps.length) * 100 + "%";
    }

    var previous = root.querySelector("[data-quiz-prev]");
    var next = root.querySelector("[data-quiz-next]");
    if (previous) previous.hidden = nextStep === 0;
    if (next) next.textContent = nextStep === steps.length - 1 ? "Show my edit" : "Next";

    setMessage(root, "");
  }

  function setMessage(root, text) {
    var message = root.querySelector("[data-quiz-message]");
    if (message) message.textContent = text || "";
  }

  function handleAnswer(root, answer) {
    var group = answer.closest("[data-answer-group]");
    if (!group) return;

    var isMulti = group.getAttribute("data-answer-mode") === "multi";
    var isSelected = answer.getAttribute("aria-pressed") === "true";

    if (!isMulti) {
      Array.prototype.slice.call(group.querySelectorAll("[data-answer]")).forEach(function (item) {
        item.setAttribute("aria-pressed", "false");
      });
    }

    answer.setAttribute("aria-pressed", isMulti ? String(!isSelected) : "true");
    setMessage(root, "");
  }

  function scoreQuiz(root) {
    var scores = {};
    var selections = [];
    var answers = Array.prototype.slice.call(root.querySelectorAll("[data-answer][aria-pressed='true']"));

    answers.forEach(function (answer) {
      var label = answer.getAttribute("data-answer-label") || answer.textContent.trim();
      if (label) selections.push(label);

      splitScores(answer.getAttribute("data-score")).forEach(function (key) {
        scores[key] = (scores[key] || 0) + 1;
      });
    });

    var availableProfiles = Array.prototype.slice.call(root.querySelectorAll("[data-result-profile]")).map(function (profile) {
      return profile.getAttribute("data-result-profile");
    });

    var ranked = Object.keys(scores).sort(function (a, b) {
      var scoreDiff = scores[b] - scores[a];
      if (scoreDiff !== 0) return scoreDiff;
      var aIndex = RESULT_PRIORITY.indexOf(a);
      var bIndex = RESULT_PRIORITY.indexOf(b);
      return (aIndex === -1 ? 99 : aIndex) - (bIndex === -1 ? 99 : bIndex);
    });

    var resultKey = ranked.find(function (key) {
      return availableProfiles.indexOf(key) !== -1;
    }) || availableProfiles[0] || "";

    return {
      resultKey: resultKey,
      selections: selections
    };
  }

  function showResults(root) {
    var scored = scoreQuiz(root);
    var panel = root.querySelector("[data-quiz-panel]");
    var results = root.querySelector("[data-quiz-results]");
    var profiles = Array.prototype.slice.call(root.querySelectorAll("[data-result-profile]"));
    var activeProfile = null;

    profiles.forEach(function (profile) {
      var isActive = profile.getAttribute("data-result-profile") === scored.resultKey;
      profile.hidden = !isActive;
      if (isActive) activeProfile = profile;
    });

    var title = activeProfile ? activeProfile.getAttribute("data-result-title") : "Your Huedra edit";
    var heading = root.querySelector("[data-results-heading]");
    var summary = root.querySelector("[data-results-summary]");
    var selections = root.querySelector("[data-results-selections]");

    if (heading) heading.textContent = title;
    if (summary) {
      summary.textContent = "Based on what you chose, this is the strongest direction to start from.";
    }

    if (selections) {
      selections.innerHTML = "";
      scored.selections.slice(0, 10).forEach(function (label) {
        var item = document.createElement("span");
        item.textContent = label;
        selections.appendChild(item);
      });
    }

    if (panel) panel.hidden = true;
    if (results) {
      results.hidden = false;
      results.focus({ preventScroll: true });
      results.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  function resetQuiz(root) {
    Array.prototype.slice.call(root.querySelectorAll("[data-answer]")).forEach(function (answer) {
      answer.setAttribute("aria-pressed", "false");
    });

    Array.prototype.slice.call(root.querySelectorAll("[data-result-profile]")).forEach(function (profile) {
      profile.hidden = true;
    });

    var panel = root.querySelector("[data-quiz-panel]");
    var results = root.querySelector("[data-quiz-results]");
    if (panel) panel.hidden = false;
    if (results) results.hidden = true;
    setStep(root, 0);
    root.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function initQuiz(root) {
    if (!root || root.dataset.artFinderQuizReady === "true") return;
    root.dataset.artFinderQuizReady = "true";

    Array.prototype.slice.call(root.querySelectorAll("[data-answer]")).forEach(function (answer) {
      answer.setAttribute("aria-pressed", "false");
    });

    root.addEventListener("click", function (event) {
      var answer = event.target.closest("[data-answer]");
      if (!answer || !root.contains(answer)) return;
      handleAnswer(root, answer);
    });

    var next = root.querySelector("[data-quiz-next]");
    var previous = root.querySelector("[data-quiz-prev]");
    var restart = root.querySelector("[data-quiz-restart]");

    if (next) {
      next.addEventListener("click", function () {
        var current = getActiveStep(root);
        var step = root.querySelector("[data-quiz-step='" + current + "']");
        if (step && selectedAnswers(step).length === 0) {
          setMessage(root, "Choose at least one option to continue.");
          return;
        }

        var totalSteps = root.querySelectorAll("[data-quiz-step]").length;
        if (current >= totalSteps - 1) {
          showResults(root);
        } else {
          setStep(root, current + 1);
        }
      });
    }

    if (previous) {
      previous.addEventListener("click", function () {
        setStep(root, Math.max(0, getActiveStep(root) - 1));
      });
    }

    if (restart) {
      restart.addEventListener("click", function () {
        resetQuiz(root);
      });
    }

    setStep(root, 0);
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll("[data-art-finder-quiz]")).forEach(initQuiz);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", function (event) {
    initQuiz(event.target.querySelector("[data-art-finder-quiz]"));
  });
})();
